"use client";

import { motion } from "framer-motion";
import { Award, BadgeCheck } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import type { University } from "@/lib/universities";
import { rankingItems, type UniversityDetail } from "@/lib/university-details";

export default function RankingSection({
  university,
  detail,
}: {
  university: University;
  detail?: UniversityDetail;
}) {
  return (
    <motion.section
      variants={stagger(0.09)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      aria-labelledby="ranking-heading"
    >
      <motion.p
        variants={fadeUp}
        className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-widest text-accent mb-3"
      >
        <Award size={14} aria-hidden="true" />
        Anerkennung
      </motion.p>
      <motion.h2
        variants={fadeUp}
        id="ranking-heading"
        className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-ink mb-6"
      >
        Anerkennung &amp; Reputation
      </motion.h2>

      <motion.ul variants={fadeUp} className="flex flex-col gap-3">
        {rankingItems(university, detail).map((item) => (
          <li
            key={item}
            className="card-flat flex items-start gap-3 bg-white/60 px-4 py-3.5 text-sm text-ink"
          >
            <BadgeCheck size={17} className="text-mint shrink-0 mt-px" aria-hidden="true" />
            {item}
          </li>
        ))}
      </motion.ul>
    </motion.section>
  );
}
